var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GridCardBasic',{attrs:{"data":_vm.medias,"empty":"Aucun média dans la collection","minCardSize":"250px"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var data = ref.data;
return [_c('CardMedia',{attrs:{"media":data},on:{"update":function($event){return _vm.$emit('update-media', data)}}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }